import * as React from "react";

// @ts-ignore
import Lottie from 'lottie-react-web'
// @ts-ignore
import checkmark from './checkmark.json'
// @ts-ignore
import greenCheckmark from './greenCheckmark.json'
// @ts-ignore
import blueCheckmark from './blueCheckmark.json'
// @ts-ignore
import loading from './loading.json'
// @ts-ignore
import loader from './loader.json'
// @ts-ignore
import loading_colors from './loading_colors.json'

interface IProps {
    animationName: string
    loop? : boolean
}

const animations = {checkmark, greenCheckmark, loader, blueCheckmark, loading, loading_colors};

export default class LottieAnimation  extends React.Component<
    IProps
    > {
    public render() {
        return (
            <Lottie
                options={{
                    animationData: animations[this.props.animationName],
                    loop: this.props.loop,
                }}
            />
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/LottieAnimation/LottieAnimation.tsx